import React, {Component} from 'react'
import {Card, CardBody, Input} from "reactstrap"
import ReGenerateFilters from './filters/ReGenerateFilters'
import ReGenerateLabelsTable from './table/ReGenerateLabelsTable'
import classNames from "classnames"
import ReactPaginate from "react-paginate"
import {LIMIT} from "../helpers/filterLists"
import AddNewOrderNumber from "./actions/AddNewOrderNumber"
import AddNewFileModal from "./actions/AddNewFileModal"
import {getReGenLabels} from '../../../services/api/apiReGenerateLabel'
import PubSub from "pubsub-js"

class ReGenerateLabelsPage extends Component {
    state = {
        labels: [],
        loading: false,
        page: 1,
        total: 0,
        limit: 50,
        error: '',
        filters: {
            barcode: '',
            reason: '',
            status: 'approved.pending'
        },
        arrSelected: [],
        selectAll: false
    }

    componentDidMount() {
        this._getReGenLabels()
        PubSub.subscribe('LIST_RE_GENERATE', this._getReGenLabels)
    }

    _parseOrderNumber = (string) => {
        const regex = /[0-9]{6,}/
        const regex2 = /#?([0-9]{6,})(_[0-9]+)/
        const parsed = string.match(regex2)
        const parsed2 = string.match(regex)

        if (parsed !== null && parsed.length >= 3) {
            return parsed[1]
        } else if (parsed2 !== null && parsed2.length >= 1) {
            return parsed2[0]
        } else {
            return string
        }
    }

    _getReGenLabels = async () => {
        this.setState({
            loading: true,
            error: '',
            arrSelected: [],
            selectAll: false
        })

        try {
            const {filters, page, limit} = this.state
            const barcodeParse = this._parseOrderNumber(filters.barcode)

            const payload = {
                ...filters,
                barcode: barcodeParse,
                page,
                limit
            }

            const {data: respons} = await getReGenLabels(payload)
            const {success, data, message} = respons

            if (!success) return this.setState({
                error: message,
                loading: false
            })

            const {rows, total} = data

            this.setState({
                labels: rows,
                total,
                loading: false
            })
        } catch (e) {
            this.setState({
                error: e.message,
                loading: false
            })
        }
    }

    _handleChangeLimit = (e) => {
        const {name, value} = e.target

        this.setState({
            [name]: value,
            page: 1
        }, () => {
            this._getReGenLabels()
        })
    }

    _handlePageClick = (page) => {
        const newPage = page.selected

        this.setState({
            page: parseInt(newPage) + 1
        }, () => {
            this._getReGenLabels()
        })
    }

    _handleChangeFilters = (filters) => {
        this.setState({
            filters: {
                ...filters,
            },
            page: 1
        }, () => {
            this._getReGenLabels()
        })
    }

    _updateSelectedGenLabel = (id, isAdded) => {
        this.setState(({arrSelected}) => {
            if (isAdded && !arrSelected.includes(id)) {
                return {
                    arrSelected: [...arrSelected, id],
                    selectAll: arrSelected.length + 1 === this.state.labels.length,
                }
            } else {
                const filtered = arrSelected.filter(item => item !== id)

                return {
                    arrSelected: filtered,
                    selectAll: false,
                }
            }
        })
    }

    _handleCheckALl = (isChecked) => {
        this.setState(() => {
            if (isChecked) {
                const {labels} = this.state
                const labelID = labels.map(item => item.approved_status === 'pending' && item._id)
                const listLabel = labelID.filter(item => item !== false)

                return {
                    arrSelected: listLabel,
                    selectAll: true,
                }
            }

            return {
                arrSelected: [],
                selectAll: false,
            }
        })
    }

    _clearSelected = () => {
        this.setState({
            arrSelected: [],
            selectAll: false
        })
    }

    render() {
        const {labels, filters, loading, error, total, limit, page, arrSelected, selectAll} = this.state
        const pages = Math.ceil(total / limit)

        return (
            <div className="ReGenerateLabelsPage">
                <Card>
                    <div className="CardHeader card-header header-elements-inline">
                        <div className="header-elements d-flex justify-content-between align-items-center w-100">
                            <h1 className='card-title'>Generate lại Labels</h1>
                            <div className="actions">
                                <div className="d-flex">
                                    <AddNewOrderNumber resetListRegenLabel={this._getReGenLabels}/>
                                    <AddNewFileModal resetListRegenLabel={this._getReGenLabels}/>
                                </div>
                            </div>
                        </div>
                    </div>

                    <CardBody>
                        <ReGenerateFilters filters={filters} onChangeFilters={this._handleChangeFilters}/>
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <div>{error && <div className="text-danger">{error}</div>}</div>
                            <div className='d-flex align-items-center'>
                                <div className='d-flex align-items-center mr-3'>
                                    <div>Hiển thị</div>
                                    <Input type='select' value={limit} name='limit' onChange={this._handleChangeLimit}
                                           className='ml-1 mr-1 w-auto'>
                                        {
                                            LIMIT.map(item => {
                                                return <option key={item.value} value={item.value}>{item.name}</option>
                                            })
                                        }
                                    </Input>
                                </div>
                                <div>
                                    Tổng số <strong>{total}</strong> items
                                </div>
                            </div>
                        </div>

                        <ReGenerateLabelsTable
                            labels={labels}
                            loading={loading}
                            arrSelected={arrSelected}
                            refreshList={this._getReGenLabels}
                            selectAll={selectAll}
                            onCheckALl={this._handleCheckALl}
                            onSelected={this._updateSelectedGenLabel}
                            clearSelected={this._clearSelected}
                        />

                        {
                            labels.length > 0 &&
                            <div className="mt-3 float-right">
                                <ReactPaginate
                                    forcePage={page - 1}
                                    previousLabel='Previous'
                                    previousClassName='page-item previous'
                                    previousLinkClassName='page-link'
                                    nextLabel='Next'
                                    nextClassName='page-item next'
                                    nextLinkClassName='page-link'
                                    breakLabel='...'
                                    breakClassName='break-me'
                                    pageCount={pages}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={5}
                                    onPageChange={this._handlePageClick}
                                    containerClassName={classNames('pagination', {loading})}
                                    pageClassName='page-item'
                                    pageLinkClassName='page-link'
                                    activeClassName='active'/>
                            </div>
                        }
                    </CardBody>
                </Card>
            </div>
        )
    }
}

export default ReGenerateLabelsPage